module.exports = __webpack_public_path__ + "assets/img/everyday_centre.279b4212.png";